module.exports = __webpack_public_path__ + "static/one-properties-logo-795b16f333cb60fee095734aef971da7.jpeg";